// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5nSQl","type":"styles_type__2daj2","choices":"styles_choices__36xPa"};